<template>
    <div class="page__home">
        <!--<mapbox style="width: 400px; height: 400px"-->
                <!--access-token="pk.eyJ1IjoidGF5YXEiLCJhIjoiY2pqNWttc3pnMDF5YTNrcGZ2MjgxdnJmcSJ9.FYBtnxzTWi0BhKf4d0xyog"-->
                <!--:map-options="{-->
      <!--style: 'mapbox://styles/mapbox/streets-v9',-->
      <!--center: [-96, 37.8],-->
      <!--zoom: 3-->
  <!--}"-->
                <!--:geolocate-control="{-->
      <!--show: false,-->
      <!--position: 'top-left'-->
  <!--}"-->
                <!--:scale-control="{-->
      <!--show: false,-->
      <!--position: 'top-left'-->
  <!--}"-->
                <!--:fullscreen-control="{-->
      <!--show: false,-->
      <!--position: 'top-left'-->
  <!--}">-->
        <!--</mapbox>-->





        <Header class="header_black"/>
        <div class="content_wrapper">
            <div class="fader"></div>
            <div class="mobile_brands_list"><Brands/></div>
            
            <Preloader/>
            
            <full-page :options="options">
                <div class="section" data-anchor="home"><Hero/></div>
                <div class="section" data-anchor="approach"><Process/></div>
                <div class="section scrollBox" data-anchor="scale"><Channel/></div>
                <div class="section" data-anchor="brands">
                    <div class="slide"><Categories/></div>
                    <div class="slide brList" data-anchor="all_brands"><Brands/></div>
                </div>
                <div class="section" data-anchor="marketing_support"><Marketing/></div>
                <div class="section" data-anchor="customer_service"><Service/></div>
                <div class="section autoBox" data-anchor="software_integration">
                    <Automation/>
                    <Footer/>
                </div>
            </full-page>
        </div>
        
        
        <div id="vidget_counter" :data-current="activeVidget">
            <span class="vg_counter">
                0
                <span data-vidget="1">1</span>
                <span data-vidget="2">2</span>
                <span data-vidget="3">3</span>
                <span data-vidget="4">4</span>
                <span data-vidget="5">5</span>
                <span data-vidget="6">6</span>
                <span data-vidget="7">7</span>
            </span><span class="vg_all"> / 07</span>
        </div>
        <div id="vidgets_navigations" :data-current="activeVidget">
            <div class="vidget_dir icon-arrow_up" @click="goPrevVidget"></div>
            <div class="vidget_dir icon-arrow_down" @click="goNextVidget"></div>
        </div>
    </div>
</template>

<script>
    import i18n from '@/lang/lang'
    import Header from '@/components/Header.vue'
    import Hero from '@/components/Hero.vue'
    import Automation from '@/components/Automation.vue'
    import Channel from '@/components/Channel.vue'
    import Service from '@/components/Service.vue'
    import Marketing from '@/components/Marketing.vue'
    import Categories from '@/components/Categories.vue'
    import Footer from '@/components/Footer.vue'
    import Process from '@/components/Process.vue'
    import Brands from '@/components/Brands.vue'
    import Preloader from '@/components/preloader.vue'
    import FullPage from 'vue-fullpage.js'
    import Mapbox from 'mapbox-gl-vue';
	
	
    export default {
        ComponentName: 'home',
        components: {
            Header,
            Footer,
            Hero,
            Automation,
            Service,
            Marketing,
            Categories,
            Channel,
            FullPage,
            Process,
            Mapbox,
            Brands,
			Preloader
        },
        data() {
            return {
                animSpeed: 100,
                lightBack: [false, false, true, true, true, true, false],
                index: 0,
                activeVidget: 1,
                options: {
                    menu: '.siteNavigation',
                    scrollOverflow: ($(window).width() < 1024)? false : true,
                    onLeave: this.onLeave,
                    afterLoad: this.afterLoad,
                    onSlideLeave: this.onSlideLeave,
                    fixedElements: '.pseudo_btns',
                    responsiveWidth: 1025,
                    touchSensitivity: 100,
                    dragAndMove: false,
                    scrollingSpeed: 700
                }
            }
        },
        methods: {
            onLeave(origin, destination, direction) {
                if(!$('body').hasClass('fp-responsive')) {
                    $('.startAnim').removeClass('startAnim startAnimBtns');
                }
                
                this.activeVidget = destination
                $('.automation__item').removeClass('visible_anim');
                
                if(this.lightBack[destination-1])
                    $('body').addClass('lightBack');
                else
                    $('body').removeClass('lightBack');
            },
            afterLoad(origin, destination, direction) {
				var _this = this;
				
                setTimeout(function() {
                    if(!$('body').hasClass('fp-responsive')) {
                        $('.startAnim').removeClass('startAnim startAnimBtns');
                    }
                    if(_this.$cookies.isKey("preloader")) {
						_this.runAll();
					}
                    else {
                        var changeDelay = ($(window).width() <= 1024)? 0 : 500;
                        
                        setTimeout(function() {
                            $('body, .fp-section.active, .fp-slide.active').addClass('startAnim');
                            if($('body').hasClass('fp-responsive')) {
                                setTimeout(function() {
                                    $('body, .fp-completely, .fp-slide.active').addClass('startAnimBtns');
                                }, 500);
                            }
                        }, 500);
                    }
                    
                    if($('.fp-completely').attr('data-anchor') == 'software_integration') {
                        _this.actWithViewport();
                    }
                }, this.animSpeed);
                
                if(this.lightBack[destination-1])
                    $('body').addClass('lightBack');
                else
                    $('body').removeClass('lightBack');
            },
            onSlideLeave(section, origin, destination, direction) {
                if(destination == 0)
                    $('body').addClass('hideHeader').removeClass('menuOpen');
                else
                    $('body').removeClass('hideHeader');
            },
            goPrevVidget() {
                $.fn.fullpage.moveSectionUp();
            },
            goNextVidget() {
                $.fn.fullpage.moveSectionDown();
            }
        },
        mounted() { 
            var _this = this;
            
            $('body').removeClass('hideTopBar').addClass('homePage');
            
            if($('body').hasClass('pPage')) {
                $('body').removeClass('pPage');
                $.fn.fullpage.moveTo('approach', true);
            }
            
            setTimeout(function() {
                $.fn.fullpage.reBuild();
            }, 500);
            
            if($('body').hasClass('fp-responsive')) {
                var scrollDelay = 0;
                $(window).scroll(function() {
                    clearTimeout(scrollDelay);
                    
                    scrollDelay = setTimeout(function() {
                        _this.scrollDetect($(this).scrollTop());
                    }, 150);
                });
            }
        },
        beforeDestroy() {
            $('body').removeClass('homePage');
            $.fn.fullpage.destroy('all');
        }
    }
</script>

<style lang="stylus" scoped>
    #vidget_counter
        position absolute
        top 200px
        right 80px
        z-index 30
        text-align right
        display none
        
        @media (min-width 1024px)
            display block
            
        @media (min-width 1600px)
            right 100px
            
    body.hideHeader #vidget_counter
        display none

    .vg_all
        display inline-block
        font-size 12px
        font-weight bold
        color rgba(#808080, .5)
        
        @media (min-width 1600px)
            font-size 14px

    .vg_counter
        display inline-block
        font-size 12px
        font-weight bold
        color #000
        position relative
        padding-right 10px
        
        @media (min-width 1600px)
            font-size 14px
    
        & > span
            font-weight bold
            position absolute
            display block
            top 0
            right 3px
            z-index 1
            opacity 0
            -webkit-transition all .3s cubic-bezier(.25,.01,.25,1)
            -moz-transition all .3s cubic-bezier(.25,.01,.25,1)
            transition all .3s cubic-bezier(.25,.01,.25,1)

    body:not(.lightBack) .vg_counter
        color #fff
            
    /* active #1 */
    #vidget_counter[data-current="1"] > .vg_counter
        & > [data-vidget="2"], & > [data-vidget="3"], & > [data-vidget="4"], & > [data-vidget="5"], & > [data-vidget="6"], & > [data-vidget="7"]
            margin-top 8px

    /* active #2 */
    #vidget_counter[data-current="2"] > .vg_counter
        & > [data-vidget="3"], & > [data-vidget="4"], & > [data-vidget="5"], & > [data-vidget="6"], & > [data-vidget="7"]
            margin-top 8px

    #vidget_counter[data-current="2"] > .vg_counter
        & > [data-vidget="1"]
            margin-top -8px

    /* active #3 */
    #vidget_counter[data-current="3"] > .vg_counter
        & > [data-vidget="4"], & > [data-vidget="5"], & > [data-vidget="6"], & > [data-vidget="7"]
            margin-top 8px

    #vidget_counter[data-current="3"] > .vg_counter
        & > [data-vidget="1"], & > [data-vidget="2"]
            margin-top -8px

    /* active #4 */
    #vidget_counter[data-current="4"] > .vg_counter
        & > [data-vidget="5"], & > [data-vidget="6"], & > [data-vidget="7"]
            margin-top 8px

    #vidget_counter[data-current="4"] > .vg_counter
        & > [data-vidget="1"], & > [data-vidget="2"], & > [data-vidget="3"]
            margin-top -8px
            
    /* active #5 */
    #vidget_counter[data-current="5"] > .vg_counter
        & > [data-vidget="6"], & > [data-vidget="7"]
            margin-top 8px

    #vidget_counter[data-current="5"] > .vg_counter
        & > [data-vidget="1"], & > [data-vidget="2"], & > [data-vidget="3"], & > [data-vidget="4"]
            margin-top -8px

    /* active #6 */
    #vidget_counter[data-current="6"] > .vg_counter
        & > [data-vidget="7"]
            margin-top 8px

    #vidget_counter[data-current="6"] > .vg_counter
        & > [data-vidget="1"], & > [data-vidget="2"], & > [data-vidget="3"], & > [data-vidget="4"], & > [data-vidget="5"]
            margin-top -8px

    /* active #7 */
    #vidget_counter[data-current="7"] > .vg_counter
        & > [data-vidget="1"], & > [data-vidget="2"], & > [data-vidget="3"], & > [data-vidget="4"], & > [data-vidget="5"], & > [data-vidget="6"]
            margin-top -8px




    #vidget_counter[data-current="1"] > .vg_counter
        & > [data-vidget="1"]
            opacity 1
            margin-top 0
    
    #vidget_counter[data-current="2"] > .vg_counter
        & > [data-vidget="2"]
            opacity 1
            margin-top 0

    #vidget_counter[data-current="3"] > .vg_counter
        & > [data-vidget="3"]
            opacity 1
            margin-top 0

    #vidget_counter[data-current="4"] > .vg_counter
        & > [data-vidget="4"]
            opacity 1
            margin-top 0

    #vidget_counter[data-current="5"] > .vg_counter
        & > [data-vidget="5"]
            opacity 1
            margin-top 0

    #vidget_counter[data-current="6"] > .vg_counter
        & > [data-vidget="6"]
            opacity 1
            margin-top 0

    #vidget_counter[data-current="7"] > .vg_counter
        & > [data-vidget="7"]
            opacity 1
            margin-top 0
    
    
    #vidgets_navigations
        width 40px
        position absolute
        right 70px
        bottom 60px
        z-index 100
        display none
        
        @media (min-width 1024px)
            display block
            
        @media (min-width 1600px)
            right 90px
    
    body.hideHeader #vidgets_navigations
        display none

    .vidget_dir
        width 40px
        height 40px
        cursor pointer
        text-align center
        line-height 40px
        font-size 14px
        color #C6C8CC
        -webkit-transition all .3s cubic-bezier(.25,.01,.25,1)
        -moz-transition all .3s cubic-bezier(.25,.01,.25,1)
        transition all .3s cubic-bezier(.25,.01,.25,1)
        
        &:hover
            color #fff
            
    body.lightBack .vidget_dir
        &:hover
            color #000
    
    #vidgets_navigations[data-current="1"]
        .icon-arrow_up
            opacity .5
            cursor default

            &:hover
                color #C6C8CC
        
    #vidgets_navigations[data-current="7"]
        .icon-arrow_down
            opacity .5
            cursor default
            
            &:hover
                color #C6C8CC
    
    
    
    
    
    
    
    
    .page__home
        background #222

    
</style>